<template>
  <div class="Script">
    <div class="Script_left">
      <div>
        <span class="el-icon-caret-right"></span>
        <span class="span1">全部（{{ total }}）</span>
        <span class="el-icon-plus"></span>
        <span class="span2" @click="NewlyBuild" style="cursor: pointer">新建</span>
        <!-- <span class="span3">
                         <span class="el-icon-arrow-right"></span>
        </span>-->
      </div>
      <div>
        <el-tree @node-click="handleNodeClick" :data="data" :props="defaultProps" default-expand-all highlight-current node-key="Id" ref="treeList">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <span v-show="data.Id != Id">{{ data.Name }}</span>
            <span v-show="data.Id == Id" class="node_span">
              <el-input @blur="onblur(data)" v-model="Name" placeholder="请输入内容"></el-input>
            </span>
            <el-popover trigger="hover" placement="bottom">
              <p style="text-align: center; margin-bottom: 10px" @click="AddGrouping(node, data)">新增下级分组</p>
              <p style="text-align: center; margin-bottom: 10px" @click="EditGrouping(node, data)">编辑</p>
              <p style="text-align: center" @click="DeleteGrouping(node, data)">删除</p>
              <span slot="reference" class="el-icon-s-tools"></span>
            </el-popover>
          </div>
        </el-tree>
      </div>
    </div>
    <div class="Script_right">
      <div class="Script_right_1">
        <div>
          <span>
            <el-input v-model="input" placeholder="请输入内容"></el-input>
          </span>
          <span style="margin-left: 10px">
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          </span>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="AddProblem">添加</el-button>
        </div>
      </div>
      <div style="margin-bottom: 20px">当前知识库共包含{{ answerTotal }}问题</div>
      <div class="Script_right_2">
        <el-table border :data="tableData" :header-cell-style="{ background: 'rgb(240, 247, 253)' }" style="width: 100%">
          <el-table-column align="center" prop="Text" label="标准问题 " width="180"></el-table-column>
          <el-table-column align="center" prop="KeyWordCount" label="关键词" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.KeyWords.length === 0">无</div>
              <el-tag v-else v-for="(item, index) in scope.row.KeyWords" :key="index" :disable-transitions="false" @close="handleClose(item)">{{ item.Text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="KeyWordCount" label="内容" width="480">
            <template slot-scope="scope">
              <!-- <div v-html="scope.row.Answers[0].Text"></div> -->
              <el-popover style="padding: 20px" placement="top-start" width="1000" trigger="hover" :content="scope.row.Answers[0].showIts">
                <div slot="reference">{{ scope.row.Answers[0].showIt }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="UpdateTime" label="更新时间"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-link @click="handleClick(scope.row)" style="margin-right: 10px">
                <i class="el-icon-edit"></i>
                编辑
              </el-link>
              <el-link @click="handleClickRemove(scope.row)">
                <i class="el-icon-delete"></i>
                删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog title="新增目录" :visible.sync="dialogVisible1" width="30%">
      <div>
        <el-input v-model="parameter.Name" placeholder="请输入内容"></el-input>
      </div>
      <div slot="footer" class="btn">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="determine1">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增下级目录" :visible.sync="dialogVisible2" width="30%">
      <div>
        <el-input v-model="parameter.Name" placeholder="请输入内容"></el-input>
      </div>
      <div slot="footer" class="btn">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="determine2">确 定</el-button>
      </div>
    </el-dialog>

    <div class="drawer_box">
      <el-drawer :visible.sync="drawer" @close="handleCloseDrawer" :wrapperClosable="false" :destroy-on-close="true">
        <div>
          <el-form ref="form" label-width="80px">
            <el-form-item label="选择分组:">
              <el-cascader v-model="GroupId" :options="options" :props="defaultProps" :show-all-levels="false" @change="change" checkStrictly></el-cascader>
            </el-form-item>
            <el-form-item label="标准:">
              <el-input v-model="problemparameter.Text" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div class="keyword">
            <el-tag v-show="KeyWords.length != 0" :key="index" v-for="(item, index) in KeyWords" closable :disable-transitions="false" @close="handleClose(item)">{{ item.Text }}</el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+添加关键词</el-button>
          </div>
          <div class="problem_box">
            内容：
            <problem :item="Answers[0]"></problem>
          </div>
          <div class="link_btn">
            <el-upload class="upload-demo" action="#" multiple :file-list="fileList" :auto-upload="false" :on-change="handleFileChange" :on-remove="handleRemove">
              <span class="el-icon-plus"></span>
              添加附件
            </el-upload>
          </div>
          <div class="btn">
            <el-button @click="drawer = false">取 消</el-button>
            <el-button type="primary" @click="Adddrawer">确 定</el-button>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import RobotCenter from '../../api/RobotCenter';
import problem from './problem.vue';
export default {
  data() {
    return {
      value: [],
      textarea: '',
      visible: false,
      form: {
        region: ''
      },
      tableData: [],
      defaultProps: {
        children: 'Children',
        label: 'Name',
        value: 'Id'
      },
      input: '',
      dialogVisible1: false,
      dialogVisible2: false,
      drawer: false,
      Name: '',
      data: [],
      Id: '',
      GroupId: [],
      parameter: {
        Name: '',
        Id: null
      },
      options: [],
      Answers: [
        {
          id: this.newGuid(),
          Text: '',
          Index: 1,
          NextAction: '01'
        }
      ],
      problem: [],
      index: 1,
      KeyWords: [],
      inputVisible: false,
      inputValue: '',
      problemparameter: {
        Text: '',
        Answers: [],
        KeyWords: [],
        Files: []
      },
      fileList: [],
      total: 0,
      answerTotal: 0,
      flag: 0, //0新增 1编辑
      row: {}
    };
  },
  components: {
    problem
  },
  created() {
    this.GroupGetTree();
  },
  mounted() {},
  methods: {
    handleFileChange(file, fileList) {
      let arr = [];
      this.fileList = fileList;
      this.fileList.forEach(i => {
        // console.log(i.hasOwnProperty("percentage"));
        if (i.hasOwnProperty('percentage')) {
          arr.push(i.raw);
        }
      });
      this.problemparameter.Files = arr;
    },
    handleRemove(file, fileList) {
      let arr = [];
      let arr2 = [];
      this.fileList = fileList;
      this.fileList.forEach(i => {
        if (i.hasOwnProperty('percentage')) {
          arr.push(i.raw);
        } else {
          arr2.push(i);
        }
      });
      this.problemparameter.Files = arr;
      this.problemparameter.Attachments = arr2;
    },
    handleNodeClick(data) {
      this.QuestionGetPageList(data.Id);
    },
    clickdelete(item) {
      this.Answers = this.Answers.filter(row => {
        if (item.id != row.id) {
          return row;
        }
      });
    },
    newGuid() {
      var guid = '';
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i == 8 || i == 12 || i == 16 || i == 20) guid += '-';
      }
      return guid;
    },
    handleClose(row) {
      this.KeyWords = this.KeyWords.filter(item => {
        if (row.Id != item.Id) {
          return item;
        }
      });
    },
    handleInputConfirm() {
      if (this.inputValue === '') return (this.inputVisible = false);
      let obj = {
        Id: this.newGuid(),
        GroupId: this.problemparameter.GroupId,
        Text: this.inputValue
      };
      this.KeyWords.push(obj);
      this.inputVisible = false;
      this.inputValue = '';
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    fillin() {
      this.index++;
      const obj = {
        id: this.newGuid(),
        Text: '',
        Index: this.index,
        NextAction: '01'
      };
      this.Answers.push(obj);
    },
    change() {
      this.problemparameter.GroupId = this.GroupId[this.GroupId.length - 1];
    },
    Adddrawer() {
      this.problemparameter.Answers = this.Answers;
      this.problemparameter.KeyWords = this.KeyWords;
      if (this.flag === 0) {
        let F = new FormData();
        Object.keys(this.problemparameter).forEach(i => {
          if (Array.isArray(this.problemparameter[i])) {
            if (i === 'Files') {
              this.problemparameter[i].forEach((j, idx) => {
                F.append(`${i}[${idx}]`, j);
              });
            } else {
              this.problemparameter[i].forEach((j, idx) => {
                F.append(`${i}[${idx}].Text`, j.Text);
              });
            }
          } else {
            F.append(i, this.problemparameter[i]);
          }
        });

        RobotCenter.KnowledgeBaseQuestionAddData(F).then(res => {
          if (res.data.Status == 1) {
            this.QuestionGetPageList();
            this.drawer = false;
          } else {
            alert(res.data.message);
          }
        });
      } else if (this.flag === 1) {
        this.row.Answers = this.problemparameter.Answers;
        this.row.KeyWords = this.problemparameter.KeyWords;
        this.row.Text = this.problemparameter.Text;
        this.row.Attachments = this.problemparameter.Attachments.map(i => i.raw);
        this.row.Files = this.problemparameter.Files;

        // return
        let F = new FormData();
        Object.keys(this.row).forEach(i => {
          if (Array.isArray(this.row[i])) {
            if (i === 'Files') {
              this.row[i].forEach((j, idx) => {
                F.append(`${i}[${idx}]`, j);
              });
            } else {
              if (this.row[i].length) {
                this.row[i].forEach((j, idx) => {
                  Object.keys(j).forEach(k => {
                    F.append(`${i}[${idx}].${k}`, j[k]);
                  });
                });
              } else {
                F.append(`${i}[]`, null);
              }
            }
          } else {
            F.append(i, this.row[i]);
          }
        });

        RobotCenter.KnowledgeBaseQuestionEditData(F).then(res => {
          if (res.data.Status == 1) {
            this.QuestionGetPageList();
            this.drawer = false;
          } else {
            alert(res.data.message);
          }
        });
      }
    },
    //打开添加问题弹框
    AddProblem() {
      this.flag = 0;
      this.drawer = true;
    },
    QuestionGetPageList(GroupId, key) {
      let parameter = {
        Key: key || '',
        page: 1,
        rows: 10,
        GroupId
      };
      RobotCenter.QuestionGetPageListData(parameter).then(res => {
        if (res.data.Status == 1) {
          // 将富文本格式正则转成文本,去除&nbsp赋值给新属性showIt,当文字大于100显示...
          res.data.Data.rows.forEach(i => {
            i.Answers.forEach(j => {
              j.showIts = j.Text.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, '');
              j.showIt = j.Text.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, '');
              if (j.showIt.length > 100) {
                j.showIt = j.showIt.slice(0, 100) + '...';
              }
            });
          });
          console.log(res.data.Data.rows);
          this.tableData = res.data.Data.rows;
          this.answerTotal = res.data.Data.total;
        }
      });
    },
    //删除分组
    DeleteGrouping(node, data) {
      let parameter = [];
      parameter.push(data.Id);
      this.$confirm('此操作将永久删除该目录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          RobotCenter.KnowledgeBaseGroupDeleteData(parameter).then(res => {
            if (res.data.Status == 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
            this.GroupGetTree();
          });
        })
        .catch(() => {});
    },
    handleClickRemove(row) {
      this.$confirm('此操作将永久删除该目录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          RobotCenter.KnowledgeBaseQuestionDelData([row.Id]).then(res => {
            this.QuestionGetPageList();
          });
        })
        .catch(() => {});
    },
    //更新分组
    onblur(data) {
      this.Id = '';
      this.parameter.ParentId = data.ParentId;
      this.parameter.Name = this.Name;
      this.parameter.Id = data.Id;
      this.parameter.OrganizationId = data.OrganizationId;
      data.Name = this.Name;
      RobotCenter.KnowledgeBaseGroupEditData(this.parameter).then(res => {
        // console.log(res);
      });
    },
    EditGrouping(node, data) {
      this.Id = data.Id;
      this.visible = false;
      this.Name = data.Name;
    },
    //打开分租弹框
    NewlyBuild() {
      this.dialogVisible1 = true;
    },
    determine1() {
      this.parameter.ParentId = 0;
      RobotCenter.KnowledgeBaseGroupAddData(this.parameter).then(res => {
        if (res.data.Status == 1) {
          this.options.push(res.data.Data);
          this.data.push(res.data.Data);
          this.dialogVisible1 = false;
        } else {
          alert(res.data.Message);
        }
      });
    },
    determine2() {
      RobotCenter.KnowledgeBaseGroupAddData(this.parameter).then(res => {
        if (res.data.Status == 1) {
          this.data = this.ArrList(this.data, res.data.Data);
          this.dialogVisible2 = false;
          this.GroupGetTree();
        } else {
          alert(res.data.Message);
        }
      });
    },
    recursion(arr) {
      return arr?.map(item => {
        if (item.Children.length != 0) {
          this.recursion(item.Children);
        } else {
          delete item.Children;
        }
        return item;
      });
    },
    ArrList(arr, data) {
      return arr?.map(item => {
        if (item.Children == null) {
          item.Children = [];
        }
        if (item.Id == this.parameter.ParentId) {
          item.Children.push(data);
        } else {
          this.ArrList(item.Children, data);
        }
        return item;
      });
    },
    //知识库分组树形结构
    GroupGetTree() {
      const parameter = {
        RobotId: this.$route.query.Id
      };
      RobotCenter.GroupGetTreeData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.data = JSON.parse(JSON.stringify(res.data.Data));
          this.options = this.recursion(res.data.Data);
          // this.QuestionGetPageList(this.data[0]?.Id);
          this.QuestionGetPageList();
          this.total = res.data.Data.length;
          this.$nextTick(() => {
            this.$refs['treeList'].setCurrentKey(1000); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
          });
        }
      });
    },
    AddGrouping(node, data) {
      this.parameter.ParentId = data.Id;
      this.dialogVisible2 = true;
    },
    //编辑问题
    handleClick(row) {
      this.flag = 1;
      this.row = row;
      this.drawer = true;
      if (row.Answers.length === 0) row.Answers.push({ Text: '' });
      this.fileList = row.Attachments.map(i => {
        return {
          name: i.Name,
          raw: i,
          size: i.Size
        };
      });
      this.problemparameter.Attachments = this.fileList;
      this.problemparameter.Text = row.Text;
      this.problemparameter.Answers = row.Answers;
      this.problemparameter.KeyWords = row.KeyWords;

      this.Answers = row.Answers;
      this.KeyWords = JSON.parse(JSON.stringify(row.KeyWords));
      this.GroupId = [row.GroupId];
    },
    handleCloseDrawer() {
      this.problemparameter.Text = '';
      this.problemparameter.Answers = [];
      this.problemparameter.KeyWords = [];
      this.problemparameter.Files = [];
      this.GroupId = [];
      this.Answers = [
        {
          Text: ''
        }
      ];
      this.KeyWords = [];
      this.fileList = [];
    },
    handleQuery() {
      this.QuestionGetPageList('', this.input);
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.el-drawer__header) {
  padding: 0;
  margin: 0;
}

.problem_box {
  position: relative;

  .el-icon-delete {
    font-size: 24px;
    position: absolute;
    right: 20px;
    top: 18px;
    cursor: pointer;
  }
}

.el-tag {
  margin-right: 10px;
}

.keyword {
  margin-bottom: 20px;
}

.link_btn {
  margin: 10px 0;
  color: #3388ff;
}

.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.drawer_box {
  /deep/.el-drawer__body {
    padding: 0px 30px 10px 30px;
    box-sizing: border-box;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.node_span {
  /deep/.el-input__inner {
    height: 30px;
  }
}

span {
  display: inline-block;
}

.el-icon-plus {
  color: #3388ff;
}

.Script {
  margin-top: 30px;

  .Script_left {
    width: 240px;
    height: 700px;
    border: 1px solid #ebebeb;
    float: left;
    padding: 20px;
    box-sizing: border-box;

    .span2 {
      color: #3388ff;
      margin-right: 20px;
    }

    .span3 {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #3388ff;
      text-align: center;
      line-height: 20px;
      color: #3388ff;
    }
  }

  .Script_right {
    float: left;
    width: 1400px;
    height: 700px;
    margin-left: 20px;

    .Script_right_1 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
}
/deep/ .el-popover--plain {
  padding: 25px !important;
}
/deep/ .el-tooltip,
.el-popover__reference {
  cursor: pointer;
}
</style>
